import axios from "axios";
import { cmsHeaders } from "../exports/exports";

export const fetchFacilitiesList = async () => {
  try {
    const response = await axios.get(
      `${process.env.REACT_APP_cmsUrl}/content-manager/facilities-facilities-list`,
      { headers: cmsHeaders },
    );
    return response.data;
  } catch (error) {
    console.error("Server Error");
  }
};
